import { Box, LinearProgress, SxProps, Theme, Typography } from "@mui/material";
import { TaskLink } from "../../../api/Tasks";

// ChecklistProgress is how far through its checklist a task is. It stays hidden until
// an item is ticked off.
export function ChecklistProgress(props: {
    value: TaskLink[];

    // sx is the space around the bar. No space is left while the bar is hidden.
    sx?: SxProps<Theme>;
}) {
    const done = props.value.filter(link => !!link.completedAt).length;
    const total = props.value.length;

    if (done === 0) return null;

    return (
        <Box sx={[{ position: "relative" }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}>
            <LinearProgress
                variant="determinate"
                color="success"
                value={done / total * 100}
                sx={{
                    height: 16, borderRadius: 2, bgcolor: "grey.200",
                    "& .MuiLinearProgress-bar": { bgcolor: "success.light", borderRadius: 2 },
                }}
            />
            <Typography
                variant="caption"
                sx={{
                    position: "absolute", inset: 0,
                    display: "flex", alignItems: "center", justifyContent: "flex-end",
                    pr: 1,
                    fontSize: 11, fontWeight: 600, lineHeight: 1,
                    // the label sits on the pale track until the fill reaches it
                    color: done === total ? "common.white" : "text.primary",
                }}
            >
                {done} / {total}
            </Typography>
        </Box>
    );
}
